/**
 * Opmaak voor de oude klantblokken (voeding, dieren) en Beheer: datum,
 * leeftijd en de "onbekend"-regel.
 *
 * De backend stuurt UTC; hier wordt daar pas Nederlands van gemaakt.
 * De v4-klantpagina is in sessie 73 opgeruimd; wat hier nog staat
 * wordt nog gebruikt.
 */

/** Een ISO-moment of datum naar alleen de dag. */
export function datumKort(iso: string | null | undefined): string {
  if (!iso) return "";
  const moment = new Date(iso);
  if (Number.isNaN(moment.getTime())) return "";
  return moment.toLocaleDateString("nl-NL", {
    timeZone: "Europe/Amsterdam",
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

/** Leeftijd in maanden naar jaren en maanden, in het Nederlands. */
export function leeftijdTekst(maanden: number | null | undefined): string {
  if (maanden === null || maanden === undefined) return "leeftijd onbekend";
  if (maanden < 24) return `${maanden} maanden`;
  return `${Math.floor(maanden / 12)} jaar`;
}

/**
 * De regel "onbekend, vraag na" bij een dier.
 *
 * Geeft een lege string als er niets ontbreekt; het scherm zet er dan
 * ook niets neer in plaats van een geruststellende zin.
 */
export function onbekendTekst(velden: string[]): string {
  if (velden.length === 0) return "";
  if (velden.length === 1) return `${velden[0]} onbekend, vraag na`;
  const laatste = velden[velden.length - 1];
  const eerste = velden.slice(0, -1).join(", ");
  return `${eerste} en ${laatste} onbekend, vraag na`;
}
